import { Controller } from '@hotwired/stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
	static targets = ['modal', 'modalDate', 'cancelDate']
  static values = { listUrl: String, actionUrl: String, cancellingStatus: String }

	delete() {
    Rails.ajax({
      url: this.actionUrlValue,
      type: 'DELETE',
      success: (response) => {
        // if (response.success) {
        //   location.reload()
        // }
      }
    })
	}

  unregister() {
    if (!this.cancelDateTarget.value) return
    const formData = new FormData()
    formData.append('corporation[cancel_date]', this.cancelDateTarget.value)
    formData.append('corporation[status]', this.cancellingStatusValue)
    Rails.ajax({
      url: this.actionUrlValue,
      type: 'PATCH',
      dataType: 'json',
      data: formData,
      success: (response) => {
        if (response.success) {
          this.openModal()
        }
      }
    })
	}

  openModal() {
    this.modalDateTarget.innerText = this.cancelDateTarget.value.replaceAll('-', '/')
    this.modalTarget.setAttribute('style', 'display: block;')
  }

  closeModal() {
    this.modalTarget.setAttribute('style', 'display: none;')
    location.replace(this.listUrlValue);
  }
}
